var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scoring-criterion"},[_c('div',{staticClass:"scoring-control"},[_c('scoring-control-select',{attrs:{"score":1,"max-score":10,"min-score":1}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }